import { deleteCookie } from 'cookies-next';
import { cookies } from '../cookies/cookies.js';

/**
 * Is One Trust Initialized?
 */ const isInitialized = async ()=>{
    return new Promise((resolve)=>{
        let attempts = 5;
        const attempt = ()=>{
            if (typeof window.OnetrustActiveGroups === 'string' && typeof window.OneTrust === 'object') {
                resolve(true);
            }
            if (attempts > 0) {
                attempts--;
                setTimeout(attempt, 1000);
            } else {
                resolve(false);
            }
        };
        attempt();
    });
};
/**
 * Check for Performance Category.
 */ const hasPerformanceCategory = ()=>{
    return typeof window.OnetrustActiveGroups !== 'string' || window.OnetrustActiveGroups.includes('C0002,');
};
/**
 * Check for Targeting Category.
 */ const hasFunctionalCategory = ()=>{
    return typeof window.OnetrustActiveGroups !== 'string' || window.OnetrustActiveGroups.includes('C0003,');
};
/**
 * Check for Targeting Category.
 */ const hasTargetingCategory = ()=>{
    return typeof window.OnetrustActiveGroups !== 'string' || window.OnetrustActiveGroups.includes('C0004,');
};
/**
 * Clear Performance Cookies.
 */ const clearPerformanceCookies = (additionalCookies = [])=>{
    [
        ...cookies,
        ...additionalCookies
    ].forEach(({ domain = undefined, cookies })=>{
        cookies.forEach(({ name, path = '/', sameSite = undefined })=>{
            deleteCookie(name, {
                domain,
                path,
                sameSite
            });
        });
    });
};
/**
 * Snapshot Current Active Group.
 */ const snapshotCurrentActiveGroup = ()=>{
    const oneTrustActiveGroups = window.OnetrustActiveGroups;
    window.OneTrust?.OnConsentChanged(()=>{
        if (window.OnetrustActiveGroups !== oneTrustActiveGroups) window.location.reload();
    });
};
/**
 * Open One Trust Overlay.
 */ const toggleInfoDisplay = ()=>{
    window.OneTrust?.ToggleInfoDisplay();
};
const controller = {
    isInitialized,
    hasPerformanceCategory,
    hasFunctionalCategory,
    hasTargetingCategory,
    clearPerformanceCookies,
    snapshotCurrentActiveGroup,
    toggleInfoDisplay
};

export { controller };
//# sourceMappingURL=controller.js.map
